export const UserPath = '/users';
export const UserUrls = {
  page: `${UserPath}`,
  verifyUser: `${UserPath}/verify/:token`,
  resetPassword: `${UserPath}/reset-password/:token`,
  login: `${UserPath}/login`,
  register: `${UserPath}/register`,
  sendResetPassword: `${UserPath}/send-reset-password`,
};
